import Image from 'next/legacy/image';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { FC, useCallback, useState } from 'react';

import { MICROCOPY } from 'src/data/microcopy/microcopyDictionary';
import { IconArrowRight } from 'src/general/Icons/IconArrowRight';
import { BasicModal } from 'src/general/components/BasicModal/BasicModal';
import { Countdown } from 'src/general/components/Countdown/Countdown';
import { carmaGenericImageLoader } from 'src/general/helpers/carmaGenericImageLoader';
import { getMicrocopy } from 'src/stores/microcopyStore';
import { BaseCarData } from 'src/types/Car.types';

import styles from './CartCarSwitchModal.module.scss';

interface Props {
  cartExpiry: Date | null;
  carCart: BaseCarData;
  car: BaseCarData;
}

export const CartCarSwitchModal: FC<Props> = ({ carCart, cartExpiry, car }) => {
  const [isOpen, setIsOpen] = useState<boolean>(true);
  const onClose = useCallback(() => {
    setIsOpen(false);
  }, [setIsOpen]);

  return (
    <BasicModal
      id="cart-switch"
      isOpen={isOpen}
      onClose={onClose}
      title={getMicrocopy(MICROCOPY.PDP_CART_SWITCH_TITLE)}
    >
      <div className={styles.description}>{getMicrocopy(MICROCOPY.PDP_CART_SWITCH_DESCRIPTION, true)}</div>
      <CarTile type="car" car={car} />
      <CarTile type="cart" car={carCart} cartExpiry={cartExpiry} />
    </BasicModal>
  );
};

type TileProps = { type: 'car'; car: BaseCarData } | { type: 'cart'; car: BaseCarData; cartExpiry: Date | null };

const CarTile: FC<TileProps> = (props) => {
  const router = useRouter();
  return (
    <Link
      prefetch={false}
      data-testid="CartCarSwitchModal-carTile-checkout"
      href={`/checkout?sku=${props.car.sku}${props.type === 'car' ? '&action=overwrite' : ''}`}
      onClick={() => {
        router.push(`/checkout?sku=${props.car.sku}${props.type === 'car' ? '&action=overwrite' : ''}`);
      }}
      className={styles.tile}
    >
      <div className={styles.tileHeader}>
        {getMicrocopy(
          props.type === 'car' ? MICROCOPY.PDP_CART_SWITCH_NEW_PURCHASE : MICROCOPY.PDP_CART_SWITCH_EXISTING_PURCHASE,
          true,
        )}
      </div>
      <div className={styles.tileCountdown}>{props.type === 'cart' && <Countdown countdown={props.cartExpiry} />}</div>
      <div className={styles.tileIcon}>
        <IconArrowRight />
      </div>
      <div className={styles.tileImage}>
        <Image src={props.car.imageUrl} loader={carmaGenericImageLoader} width={120} height={68} alt="" />
      </div>
      <div className={styles.tileCar}>
        <div className={styles.tileCarModel}>{props.car.model}</div>
        <div className={styles.tileCarVariant}>{props.car.variant}</div>
      </div>
    </Link>
  );
};
